export default __webpack_public_path__ + "static/media/line-v-01.ed90a70e.png";